import { Link } from 'react-router-dom'
import { Row, Section, SectionHeading } from '../components/ui'
import { useDocumentMeta, useLocale } from '../lib/hooks'
import { pathFor, t } from '../lib/i18n'

export default function NotFound() {
  const locale = useLocale()
  const strings = t(locale)
  useDocumentMeta(`${strings.notFound.title} | zvidori`)

  return (
    <Section className="!py-[120px]" data-testid="not-found">
      <Row className="text-center">
        <SectionHeading as="h1">{strings.notFound.title}</SectionHeading>
        <p className="mt-4 font-sans text-[18px] leading-[1.65] text-ink">
          {strings.notFound.body}
        </p>
        <Link
          to={pathFor(locale, 'home')}
          className="mt-8 inline-block font-sans text-[16px] font-semibold text-ink underline underline-offset-4"
        >
          {strings.notFound.home}
        </Link>
      </Row>
    </Section>
  )
}
